import { SvgProps } from 'react-native-svg';

export type BaseIconProps = {
    width: number;
    height: number;
    color: string;
};

export type CustomSVGProps = SvgProps & BaseIconProps;

export const getBaseSVGProps = (props: CustomSVGProps, viewBoxDimensions?: number): SvgProps => {
    const { height, width, color, ...rest } = props;
    return {
        width: `${width}`,
        height: `${height}`,
        viewBox: `0 0 ${viewBoxDimensions || width} ${viewBoxDimensions || height}`,
        ...rest,
    };
};
